/**
 * helper functions
 */
class Utils {
  /**
   * This API will check whether the reference is page instruction
   * @param reference reference of the property
   * @returns returns true if the reference is a page instruction
   */
  static isPageInstruction(reference: string) {
    return reference && reference.includes('[') && reference.includes(']');
  }
}

export default Utils;
